import { initializeApp, getApps } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, writeBatch } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
apiKey: "AIzaSyA_hHywUKYTyBbKwyayylGAJO9xhakUnsI",
authDomain: "clublink-software.firebaseapp.com",
projectId: "clublink-software",
storageBucket: "clublink-software.firebasestorage.app",
messagingSenderId: "961615485562",
appId: "1:961615485562:web:74c4c99289edba53bcf9c3",
measurementId: "G-9S8ECT7EB9"
  };

// Initialize primary app (for logged-in admin session)
const firebaseApp = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);
const auth = getAuth(firebaseApp);
const db = getFirestore(firebaseApp);
const storage = getStorage(firebaseApp);
const functions = getFunctions(firebaseApp);

// Initialize secondary app for creating users without affecting admin login
const secondaryApp =
getApps().find(app => app.name === "SECONDARY") ||
initializeApp(firebaseConfig, "SECONDARY");
const secondaryAuth = getAuth(secondaryApp);

export { firebaseApp, auth, db, writeBatch, storage, secondaryAuth, functions };